'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isNull2 = require('lodash/isNull');

var _isNull3 = _interopRequireDefault(_isNull2);

var _filter2 = require('lodash/filter');

var _filter3 = _interopRequireDefault(_filter2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _sum2 = require('lodash/sum');

var _sum3 = _interopRequireDefault(_sum2);

var _round2 = require('lodash/round');

var _round3 = _interopRequireDefault(_round2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SERIALIZE_FIELDS, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24;

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _decimal = require('decimal.js');

var _decimal2 = _interopRequireDefault(_decimal);

var _constants = require('../constants');

var _util = require('../utils/util');

var _BaseModel2 = require('./BaseModel');

var _BaseModel3 = _interopRequireDefault(_BaseModel2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CENT = _constants.AppConstants.CENT,
    INTEREST_RATE_DECIMAL_PLACES = _constants.AppConstants.INTEREST_RATE_DECIMAL_PLACES,
    LIEN_MODELS = _constants.AppConstants.LIEN_MODELS;


var LEGAL_SERIALIZE_FIELDS = ['agreement_date', 'amount_owed_today', 'application', 'capital_fundings', 'case', 'contract_download_url', 'custom_field_data', 'fees', 'funding_amount', 'id', 'interest_start_date', 'invested_amount', 'is_confirmed', 'is_imported', 'is_open', 'link_application', 'minimum_duration', 'preset_contract_template', 'preset_contract_template_name', 'principal_amount', 'prior_funding', 'terms'];

var MEDICAL_SERIALIZE_FIELDS = ['billing_amount', 'codes', 'custom_field_data', 'id', 'is_open', 'label', 'medical_facility', 'medical_facility_contact', 'medical_provider', 'notes', 'purchase_amount', 'purchase_date', 'initial_service_date', 'end_service_date'];

var GENERIC_SERIALIZE_FIELDS = ['amount', 'custom_field_data', 'id', 'is_open', 'notes', 'acquisition_date'];

var SERIALIZE_FIELDS = (_SERIALIZE_FIELDS = {}, _defineProperty(_SERIALIZE_FIELDS, LIEN_MODELS.GENERIC.model, GENERIC_SERIALIZE_FIELDS), _defineProperty(_SERIALIZE_FIELDS, LIEN_MODELS.LEGAL_FUNDING.model, LEGAL_SERIALIZE_FIELDS), _defineProperty(_SERIALIZE_FIELDS, LIEN_MODELS.LEGACY.model, LEGAL_SERIALIZE_FIELDS), _defineProperty(_SERIALIZE_FIELDS, LIEN_MODELS.MEDICAL.model, MEDICAL_SERIALIZE_FIELDS), _SERIALIZE_FIELDS);

var LienModel = (0, _classAutobindDecorator2.default)(_class = (_class2 = function (_BaseModel) {
  _inherits(LienModel, _BaseModel);

  // istanbul ignore next
  function LienModel() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var flatStore = arguments[1];

    _classCallCheck(this, LienModel);

    var _this = _possibleConstructorReturn(this, (LienModel.__proto__ || Object.getPrototypeOf(LienModel)).call(this, flatStore));

    _initDefineProp(_this, 'agreement_date', _descriptor, _this);

    _initDefineProp(_this, 'amount_owed_today', _descriptor2, _this);

    _initDefineProp(_this, 'application', _descriptor3, _this);

    _initDefineProp(_this, 'capital_fundings', _descriptor4, _this);

    _initDefineProp(_this, 'case', _descriptor5, _this);

    _initDefineProp(_this, 'contract_download_url', _descriptor6, _this);

    _initDefineProp(_this, 'custom_field_data', _descriptor7, _this);

    _initDefineProp(_this, 'documents', _descriptor8, _this);

    _initDefineProp(_this, 'fees', _descriptor9, _this);

    _initDefineProp(_this, 'funded_date', _descriptor10, _this);

    _initDefineProp(_this, 'funding_amount', _descriptor11, _this);

    _initDefineProp(_this, 'id', _descriptor12, _this);

    _initDefineProp(_this, 'interest_start_date', _descriptor13, _this);

    _initDefineProp(_this, 'invested_amount', _descriptor14, _this);

    _initDefineProp(_this, 'is_confirmed', _descriptor15, _this);

    _initDefineProp(_this, 'is_open', _descriptor16, _this);

    _initDefineProp(_this, 'lien_returns', _descriptor17, _this);

    _initDefineProp(_this, 'link_application', _descriptor18, _this);

    _initDefineProp(_this, 'minimum_duration', _descriptor19, _this);

    _initDefineProp(_this, 'preset_contract_template', _descriptor20, _this);

    _initDefineProp(_this, 'prior_funding', _descriptor21, _this);

    _initDefineProp(_this, 'schedule_items', _descriptor22, _this);

    _initDefineProp(_this, 'terms', _descriptor23, _this);

    _initDefineProp(_this, 'type', _descriptor24, _this);

    _this.extend(data);
    return _this;
  }

  _createClass(LienModel, [{
    key: 'getTermsPercent',
    value: function getTermsPercent() {
      return (0, _mobx.toJS)(this.terms).map(function (term) {
        term.interest_rate = (0, _round3.default)(Number(term.interest_rate) * CENT, INTEREST_RATE_DECIMAL_PLACES);
        return term;
      });
    }
  }, {
    key: 'setTermPercent',
    value: function setTermPercent(idx, val) {
      var interest_rate = (0, _round3.default)(Number(val) / CENT, INTEREST_RATE_DECIMAL_PLACES);
      this.terms[idx].interest_rate = interest_rate;
    }
  }, {
    key: 'calculatedPrincipal',
    value: function calculatedPrincipal(priorFunding) {
      var fees = (0, _sum3.default)((0, _mobx.toJS)(this.feesNonFlat()).map(function (i) {
        return Number(i.fee_amount || 0);
      })),
          funding = Number((0, _get3.default)(this, 'funding_amount', 0));

      // If we have a prior funding, use that for calculation
      if (priorFunding) {
        var buyout = Number((0, _get3.default)(priorFunding, 'buyout_amount', 0));
        return Number(fees + funding + buyout) || 0;
      }

      // If no prior funding exists, respect legacy value
      var buyoutLegacy = Number((0, _get3.default)(this, 'buyout', 0));
      return Number(fees + funding + buyoutLegacy) || 0;
    }
  }, {
    key: 'feesFlat',
    value: function feesFlat() {
      return (0, _get3.default)(this, 'fees', []).filter(function (i) {
        return !i.contributes_to_principal;
      });
    }
  }, {
    key: 'feesNonFlat',
    value: function feesNonFlat() {
      return (0, _get3.default)(this, 'fees', []).filter(function (i) {
        return i.contributes_to_principal;
      });
    }
  }, {
    key: 'addFee',
    value: function addFee(options) {
      var fee = Object.assign({ fee_amount: '', fee_type: '' }, options);
      this.fees.push(fee);
    }
  }, {
    key: 'addNonFlatFee',
    value: function addNonFlatFee() {
      this.addFee({ contributes_to_principal: true });
    }
  }, {
    key: 'addFlatFee',
    value: function addFlatFee() {
      this.addFee({ contributes_to_principal: false });
    }
  }, {
    key: 'addBuyout',
    value: function addBuyout() {
      var prior_funding = Object.assign({ buyout_amount: '', expiration_date: '', funder_name: '' });
      this.extend({ prior_funding: prior_funding });
    }
  }, {
    key: 'applyPreset',
    value: function applyPreset(preset) {
      var preset_terms = (0, _pick3.default)(preset, ['minimum_duration', 'terms']);
      preset_terms.preset_contract_template = preset.id;

      this.extend(preset_terms);
    }
  }, {
    key: 'getPreset',
    value: function getPreset(presets) {
      return (0, _find3.default)(presets, { id: this.preset_contract_template });
    }
  }, {
    key: 'serialize',
    value: function serialize() {
      var serializeFields = SERIALIZE_FIELDS[this.type || LIEN_MODELS.LEGAL_FUNDING.model],
          lien = (0, _pick3.default)(this, serializeFields);

      // Remove fees with no amount
      if (this.isPlaintiffFunding) {
        lien.fees = (0, _filter3.default)(lien.fees, function (fee) {
          return !(0, _isNull3.default)(fee.fee_amount);
        });
      }

      return lien;
    }
  }, {
    key: 'calculateBalance',
    value: function calculateBalance(amount_owed) {
      var reduction_percentage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var excludeReturnAmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var returnAmountSum = this.returnAmountSum,
          reductionAmount = amount_owed * (reduction_percentage || 0),
          amountOwed = amount_owed - reductionAmount;


      if (!amountOwed || !returnAmountSum) {
        return amountOwed;
      }

      if (excludeReturnAmount) {
        return new _decimal2.default(amountOwed);
      }

      return new _decimal2.default(amountOwed).minus(new _decimal2.default(returnAmountSum));
    }
  }, {
    key: 'adjustedLienBalance',
    value: function adjustedLienBalance(amount_owed) {
      return this.calculateBalance(amount_owed);
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'returnLastRepaid',
    get: function get() {
      var stringMax = function stringMax(a, b) {
        return a > b ? a : b;
      };
      return this.lien_returns.map(function (lienReturn) {
        return lienReturn.matured_date;
      }).reduce(stringMax, '');
    }
  }, {
    key: 'returnAmountSum',
    get: function get() {
      return (0, _util.sumMoney)(this.lien_returns.map(function (lienReturn) {
        return lienReturn.actual_amount;
      }));
    }
  }, {
    key: 'returnExpectedSum',
    get: function get() {
      return (0, _util.sumMoney)(this.lien_returns.map(function (lienReturn) {
        return lienReturn.expected_amount;
      }));
    }
  }, {
    key: 'isPlaintiffFunding',
    get: function get() {
      return [LIEN_MODELS.LEGAL_FUNDING.model, LIEN_MODELS.LEGACY.model].includes(this.type);
    }
  }, {
    key: 'isMedicalFunding',
    get: function get() {
      return this.type === LIEN_MODELS.MEDICAL.model;
    }
  }, {
    key: 'isGenericLien',
    get: function get() {
      return this.type === LIEN_MODELS.GENERIC.model;
    }
  }, {
    key: 'current_lien_balance',
    get: function get() {
      return this.calculateBalance(this.amount_owed_today);
    }
  }, {
    key: 'experimental_lien_balance',
    get: function get() {
      return this.calculateBalance(this.amount_owed_today, 0, true);
    }
  }, {
    key: 'reduced_lien_balance',
    get: function get() {
      return this.calculateBalance(this.amount_owed_today, this.reduction_percentage);
    }
  }, {
    key: 'hasCoopInvestment',
    get: function get() {
      return this.amount_owed_to_coop !== null;
    }
  }]);

  return LienModel;
}(_BaseModel3.default), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'agreement_date', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'amount_owed_today', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'application', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'capital_fundings', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'case', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'contract_download_url', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'custom_field_data', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'documents', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'fees', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'funded_date', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'funding_amount', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'interest_start_date', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'invested_amount', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'is_confirmed', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'is_open', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, 'lien_returns', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, 'link_application', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, 'minimum_duration', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, 'preset_contract_template', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, 'prior_funding', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class2.prototype, 'schedule_items', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class2.prototype, 'terms', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class2.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: null
})), _class2)) || _class;

var _default = LienModel;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CENT, 'CENT', '/app/src/models/LienModel.js');
  reactHotLoader.register(INTEREST_RATE_DECIMAL_PLACES, 'INTEREST_RATE_DECIMAL_PLACES', '/app/src/models/LienModel.js');
  reactHotLoader.register(LIEN_MODELS, 'LIEN_MODELS', '/app/src/models/LienModel.js');
  reactHotLoader.register(LEGAL_SERIALIZE_FIELDS, 'LEGAL_SERIALIZE_FIELDS', '/app/src/models/LienModel.js');
  reactHotLoader.register(MEDICAL_SERIALIZE_FIELDS, 'MEDICAL_SERIALIZE_FIELDS', '/app/src/models/LienModel.js');
  reactHotLoader.register(GENERIC_SERIALIZE_FIELDS, 'GENERIC_SERIALIZE_FIELDS', '/app/src/models/LienModel.js');
  reactHotLoader.register(SERIALIZE_FIELDS, 'SERIALIZE_FIELDS', '/app/src/models/LienModel.js');
  reactHotLoader.register(LienModel, 'LienModel', '/app/src/models/LienModel.js');
  reactHotLoader.register(_default, 'default', '/app/src/models/LienModel.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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